<template>
  <div>
    <div class="grid-container">
      <main class="grid-item main">
        <div class="items">
          <slot></slot>
        </div>
      </main>
    </div>
  </div>
</template>
<script>
  export default {
    name: "ScrollTableWrapper",
    created() {
    },
    props:{
      enableDragScroll: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        ev: {
          up: undefined,
          down: undefined,
          leave: undefined,
          move: undefined,
        }
      }
    },
    mounted() {
      if(this.enableDragScroll) {
        this.setScrollTable();
      }
    },
    watch: {
      enableDragScroll() {
        this.setScrollTable();
      }
    },
    methods: {
      setScrollTable() {
        this.$nextTick(() => {
          const slider = document.querySelector('.items');
          if(this.enableDragScroll) {
            slider.style.userSelect = 'none';
            slider.style.cursor = 'move';

            let isDown = false;
            let startX;
            let scrollLeft;
            this.ev.down = (e) => {
              // console.log('pageX',e.pageX, slider.offsetLeft)
              isDown = true;
              slider.classList.add('active');
              startX = e.pageX - slider.offsetLeft;
              scrollLeft = slider.scrollLeft;
            };
            slider.addEventListener('mousedown', this.ev.down);
            this.ev.leave = (e) => {
              isDown = false;
              slider.classList.remove('active');
            }
            slider.addEventListener('mouseleave', this.ev.leave);
            this.ev.up = (e) => {
              isDown = false;
              slider.classList.remove('active');
            }
            slider.addEventListener('mouseup', this.ev.up);
            this.ev.move = (e) => {
              if (!isDown) return;
              e.preventDefault();
              const x = e.pageX - slider.offsetLeft;
              const walk = (x - startX) * 1; //scroll-fast
              slider.scrollLeft = scrollLeft - walk;
              // console.log(walk);
            }
            slider.addEventListener('mousemove', this.ev.move);
          } else {
            slider.style.userSelect = null;
            slider.style.cursor = null;

            slider.removeEventListener('mousedown', this.ev.down);
            slider.removeEventListener('mouseleave', this.ev.leave);
            slider.removeEventListener('mousemove', this.ev.move);
            slider.removeEventListener('mouseup', this.ev.up);
          }

        })
      }
    }
  }
</script>
<style lang="scss" scoped>
  //VARIABLES BECAUSE CSS PREPROCESSORS ARE COOL
  $gray: #555;
  $yellow: #f2e968;
  $white: #efefef;

  /*  //GET THE GOOGLE FONT SPECIMEN
    @import url(https://fonts.googleapis.com/css?family=Rubik);*/

  /*  body,
    html {
      color: #fff;
      text-align: center;
      background: $white;
      font-family: Helvetica, sans-serif;
      margin: 0;
    }*/

  .grid-container {
    background: $white;
    /*font-family: 'Rubik', sans-serif;*/
  }

  //ENABLE CSS GRID FOR LIFT OFF  🚀
  @supports (display: grid) {

    /*  .grid-container {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        grid-template-rows: auto 1fr auto;

        //Let the craziness begin!!!
        grid-template-areas:
          "header header header"
          "title title footer"
          "main main main";
        @media screen and (max-width: 500px) {
          grid-template-columns: 1fr;
          grid-template-rows: 0.3fr 1fr auto 1fr;
          grid-template-areas:
            "header"
            "title"
            "main"
            "footer";
        }
      }*/

    .grid-item {
      color: #fff;
      background: skyblue;
      padding: 3.5em 1em;
      font-size: 1em;
      /*font-weight: 700;*/
    }

    .header {
      background-color: darken(skyblue, 60%);
      grid-area: header;
      padding: 1em;
    }

    .title {
      color: $gray;
      background-color: lighten(skyblue, 25%);
      grid-area: title;
    }

    .main {
      color: lighten($gray, 25%);
      background-color: lighten(skyblue, 60%);
      grid-area: main;
      padding: 0;
      /*overflow-x: scroll;*/
      /*overflow-y: hidden;*/
    }

    .footer {
      background-color: darken(skyblue, 10%);
      grid-area: footer;
      padding: 0.6em;
    }

    .items {
      position: relative;
      width: 100%;
      overflow-x: auto;
      overflow-y: hidden;
      transition: all 0.2s;
      will-change: transform;
      /*user-select: none;*/
      /*cursor: pointer;*/
    }

    .items tr {
      border-bottom: 1px solid #eee;
    }

    .lp-table {
      width: 100%;
    }

    .items.active {
      background: rgba(255, 255, 255, 0.3);
      cursor: grabbing;
      cursor: -webkit-grabbing;
      /*transform: scale(1);*/
    }

    .item {
      /*display: inline-block;*/
      text-align: center;
      /*background: skyblue;*/
      /*min-height: 250px;*/
      /*min-width: 400px;*/
      padding: 1em;
      vertical-align: middle;
      @media screen and (max-width: 500px) {
        min-height: 200px;
        min-width: 200px;
      }
    }

    .admin-table {
      width: 100%;
      table-layout: fixed;
    }

    .admin-table td > div {
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 3; /* 라인수 */
      -webkit-box-orient: vertical;
      word-wrap: break-word;
      line-height: 1.2em;
    }
    .admin-table td > span {
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 3; /* 라인수 */
      -webkit-box-orient: vertical;
      word-wrap: break-word;
      line-height: 1.2em;
    }
  }
</style>
